<template>
    <div class="ah-page trade-statement-editor-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <el-button size="mini" icon="el-icon-back" type="primary" @click="$router.push({ name: 'trade-statement' })" />
                        <h1>收支範本編輯器</h1>
                        <el-select v-model="openedTemplateSno" style="width: 220px" size="small" @change="onTemplateChange">
                            <el-option v-for="template in templateList" :key="template.id" :value="template.id" :label="template.label" />
                        </el-select>
                        <el-button size="mini" type="" @click="onToggleDeployment">
                            {{ this.groupItemSetting.isDraft ? "發布" : "撤下" }}
                        </el-button>
                        <el-tag v-if="this.groupItemSetting.isDraft" type="danger" size="small">草稿</el-tag>
                        <el-tag v-else type="success" size="small">已上架</el-tag>
                        <div v-if="this.groupItemSetting.lastUpdateTime" class="last-edit-time">最後編輯：{{ lastUpdateTimeTxt }}</div>
                    </div>
                    <div class="actions">
                        <el-button size="small" type="primary" icon="el-icon-edit" @click="onEditSampleClick">編輯範本</el-button>
                        <el-button size="small" type="primary" icon="el-icon-delete" @click="onDeleteClick">刪除此範本</el-button>
                        <el-button size="small" type="primary" icon="el-icon-plus" @click="onSaveNewClick">建立新範本</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-body">
            <div class="ah-container">
                <three-columns-layout column1-width="142px" column2-width="1fr" column3-width="1.3fr">
                    <!-- 分類 -->
                    <template slot="column-1-title">
                        <div></div>
                        <div>收支分類</div>
                        <div></div>
                    </template>
                    <template slot="column-1-body">
                        <div v-for="c in statementTypes" :key="c.key" class="trade-categroy-item" :class="{ active: activeCategory === c.key }" @click="onCategoryItemClick(c.key)">
                            {{ c.value }}
                        </div>
                    </template>

                    <!-- 大群組 -->
                    <template slot="column-2-title">
                        <div></div>
                        <div>大群組</div>
                        <el-button size="mini" icon="el-icon-plus" @click="onAddNewGroup(true)" />
                    </template>
                    <template slot="column-2-body">
                        <tradeItemTable
                            v-model="groupItemSetting[activeCategory]"
                            :dataType="activeCategory"
                            :selectedItemSno="activeGroupName"
                            :isIncomeOptionUsable="isIncomeOptionUsable"
                            @dragged="onDragEnd"
                            @itemClick="onGroupItemClick"
                            @edit="onEditGroup"
                            @grp-nam-change="onGrpNamChange"
                        />
                        <div class="column-actions">
                            <el-button size="mini" icon="el-icon-plus" @click="onAddNewGroup(false)">新增群組</el-button>
                        </div>
                    </template>

                    <!-- 子項目 -->
                    <template slot="column-3-title">
                        <div></div>
                        <div>子項目</div>
                        <div>
                            <el-button v-if="activeGroupName" size="mini" icon="el-icon-plus" @click="onAddNewItem(true)" />
                        </div>
                    </template>
                    <template slot="column-3-body">
                        <tradeItemTable v-model="activeGroup.childSettings" dataType="childItems" @dragged="onDragEnd" @edit="onEditChildItem" />
                        <div class="column-actions">
                            <el-button v-if="activeGroupName" size="mini" icon="el-icon-plus" @click="onAddNewItem(false)">新增子項目</el-button>
                        </div>
                    </template>
                </three-columns-layout>
            </div>
        </div>
        <ItemDetailDialog
            :visible="itemDetailDialog.visible"
            :active-group-name="activeGroupName"
            :full-list="activeGroup.childSettings"
            :accounting-items="filterdAccountingOption(activeCategory)"
            :data="itemDetailDialog.data"
            @add="onItemDialogAdd"
            @update="onItemDialogUpdate"
            @delete="onItemDialogDelete"
            @close="onItemDialogClose"
        />
        <GroupDetailDialog
            :visible="groupDetailDialog.visible"
            :category="activeCategory"
            :active-group-name="activeGroupName"
            :full-list="groupItemSetting[activeCategory]"
            :data="groupDetailDialog.data"
            :isIncomeOptionUsable="isIncomeOptionUsable"
            @add="onGroupDialogAdd"
            @update="onGroupDialogUpdate"
            @delete="onGroupDialogDelete"
            @close="onGroupDialogClose"
        />
        <SampleDetailDialog
            :visible="sampleDetailDialog.visible"
            :id="openedTemplateSno"
            :sample-list="groupItemSettingList"
            :template-list="templateList"
            :isEditMode="sampleDetailDialog.isEditMode"
            @delete="onSampleDialogDelete"
            @close="onSampleDialogClose"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { statementTypes } from '@/assets/commonData/options';
import FirebaseSDK from '@/utils/firebaseSDK';
import moment from 'moment';
import threeColumnsLayout from './ThreeColumnsLayout.vue';
import tradeItemTable from './TradeItemTable.vue';

import itemDetailDialogMixins from './mixins/itemDetailDialogMixins';
import groupDetailDialogMixins from './mixins/groupDetailDialogMixins';
import sampleDetailDialogMixins from './mixins/sampleDetailDialogMixins';

const firebase = new FirebaseSDK();

export default {
    name: 'trade-statements-editor',
    mixins: [itemDetailDialogMixins, groupDetailDialogMixins, sampleDetailDialogMixins],
    components: { threeColumnsLayout, tradeItemTable },
    data() {
        return {
            statementTypes,
            loading: false,
            openedTemplateSno: 1,
            templateList: [],
            activeCategory: 'invoiceSettings',
            activeGroupName: null,
            groupItemSetting: {},
            groupItemSettingList: {},
        };
    },
    async mounted() {
        firebase.init(this.userSno, this.userName);
        await this.fetchAccountingOptions();

        await this.updateData(true);

        // await this.initSysVariables();
    },
    computed: {
        ...mapGetters({
            userSno: 'account/userSno',
            userName: 'account/userName',
        }),
        activeGroup() {
            if (this.activeCategory && this.activeGroupName) {
                return this.groupItemSetting[this.activeCategory].find((x) => x.iteM_NAM === this.activeGroupName);
            }
            return [];
        },
        lastUpdateTimeTxt() {
            return moment(this.groupItemSetting.lastUpdateTime).format('YYYY/MM/DD HH:mm');
        },
    },
    methods: {
        async updateData(init) {
            const { dataList, idList } = await firebase.getList();
            this.templateList = idList;
            if (init) this.openedTemplateSno = _.head(this.templateList).id;
            this.groupItemSettingList = dataList;
            this.groupItemSetting = this.groupItemSettingList[this.openedTemplateSno];
            console.log(this.groupItemSetting);
        },
        async onSave() {
            try {
                this.isLoading = true;
                await firebase.updateSample(this.openedTemplateSno, this.groupItemSetting);
                await this.updateData();
                console.log('save!');
            } finally {
                this.isLoading = false;
            }
        },

        // 表格控制
        onCategoryItemClick(key) {
            this.activeCategory = key;
            this.activeGroupName = null;
        },
        onGroupItemClick(val) {
            this.activeGroupName = val.iteM_NAM;
        },
        onEditGroup(val, index) {
            this.groupDetailDialog.visible = true;
            this.groupDetailDialog.data = val;
            this.groupDetailDialog.index = index;
        },
        onEditChildItem(val, index) {
            this.itemDetailDialog.visible = true;
            this.itemDetailDialog.data = val;
            this.itemDetailDialog.index = index;
        },
        onDragEnd(newOrder) {
            console.log('order changed', newOrder);
            this.onSave();
        },
        onGrpNamChange(val, index) {
            const FOUND = this.groupItemSetting[this.activeCategory][index];
            FOUND.grP_NAM = val;
            this.onSave();
        },

        // 範本控制
        async onToggleDeployment() {
            this.groupItemSetting.isDraft = !this.groupItemSetting.isDraft;
            await firebase.toggleDeployment(this.openedTemplateSno, this.groupItemSetting.isDraft);
            this.updateData();
        },
        onSaveNewClick() {
            this.sampleDetailDialog.visible = true;
        },
        onEditSampleClick() {
            this.sampleDetailDialog.visible = true;
            this.sampleDetailDialog.isEditMode = true;
        },
        async onDeleteClick() {
            try {
                await this.$confirm('確定要刪除？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.onSampleDialogDelete(this.openedTemplateSno);
                await this.updateData(true);
            } catch (e) {
                console.log(e);
            }
        },
        onTemplateChange() {
            this.groupItemSetting = this.groupItemSettingList[this.openedTemplateSno];
            this.activeGroupName = null;
        },
        onAddNewItem(insert) {
            this.itemDetailDialog.isInsert = insert;
            this.itemDetailDialog.visible = true;
            this.itemDetailDialog.data = null;
        },
        onAddNewGroup(insert) {
            this.groupDetailDialog.isInsert = insert;
            this.groupDetailDialog.visible = true;
            this.groupDetailDialog.data = null;
        },

        async initSysVariables() {
            const resp = await this.$api({
                url: 'Tool/GetIncomeStatementSettings',
                method: 'GET',
            });

            const DATA = {
                cInElseSettings: [],
                cInSettings: [],
                cOutElseSettings: [],
                cOutSettings: [],
                invoiceSettings: [],
                payoutSettings: [],
            };

            _.forEach(resp.data, (cValue, cKey) => {
                cValue.forEach((group) => {
                    if (!group.iS_SYS) {
                        const GROUP_DATA = {};
                        const CHILDREN = [];

                        GROUP_DATA.grP_NAM = group.grP_NAM;
                        GROUP_DATA.grP_MEM = group.grP_MEM;
                        GROUP_DATA.iteM_NAM = group.iteM_NAM;
                        GROUP_DATA.grP_AMT = group.grP_AMT;
                        GROUP_DATA.isshare = group.isshare;

                        group.childSettings.forEach((child) => {
                            const CHILD_DATA = {};

                            CHILD_DATA.grP_MEM = child.grP_MEM;
                            CHILD_DATA.accno = child.accno;
                            CHILD_DATA.accno = child.accno;
                            CHILD_DATA.accnam = child.accnam;
                            CHILD_DATA.accsno = child.accsno;
                            CHILD_DATA.suggestedAccItems = child.suggestedAccItems;
                            CHILD_DATA.iteM_NAM = child.iteM_NAM;

                            CHILDREN.push(CHILD_DATA);
                        });
                        GROUP_DATA.childSettings = CHILDREN;

                        DATA[cKey].push(GROUP_DATA);
                    }
                });
            });

            await firebase.addSample('範本1', DATA);
        },
    },
};
</script>
<style lang="scss">
.ah-page.trade-statement-editor-page {
    padding-bottom: 0;
    .page-header .title-row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        > .title {
            line-height: 50px;
            display: flex;
            align-items: center;
            gap: 10px;
            > h1 {
                font-size: 14pt;
                margin-right: 20px;
            }
            .last-edit-time {
                font-size: 9pt;
                opacity: 0.6;
                margin-left: 10px;
            }
        }
        > .actions {
            padding: 0;
        }
    }

    .trade-categroy-item {
        line-height: 35px;
        padding: 0 10px;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &:hover {
            background-color: #f7f8f9;
        }

        &.active {
            background-color: #f3f4fd;
            color: #443cab;
            font-weight: bold;
        }
    }

    .column-actions {
        text-align: right;
        margin: 10px 0;
    }
}
</style>
